/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Profile/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Location from './Location/index'
import ProfileData from './ProfileData/index'
import ProfileImage from './ProfileImage/index'
import React from 'react'
import ResourceName from './ResourceName/index'
import ViewProfessionalAction from './ViewProfessionalAction/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Profile({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/Search/Content/Profiles/Content/Profile"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Profile.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-1AREyJ': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Horizontal}`}
>
<button
  data-testid="Profile.Horizontal:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Horizontal1}`}
>
<ProfileImage
  viewPath={`${viewPath}/ProfileImage`}
/>
<div
  data-testid="Profile.Vertical"
  data-view-path={viewPath}
 style={{'--ml-2-1AREyJ': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<ProfileData
  viewPath={`${viewPath}/ProfileData`}
/>
<div
  data-testid="Profile.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<ResourceName
  viewPath={`${viewPath}/ResourceName`}
/>
<Location
  viewPath={`${viewPath}/Location`}
/>
</div>
</div>
</button>
<ViewProfessionalAction
  viewPath={`${viewPath}/ViewProfessionalAction`}
/>
</div>
{children}
</React.Fragment>)
}